<template>
    <v-row>
        <template v-for="item in items">
            <v-col cols="12" sm="6" md="4" :key="item._id">
                <main-recruitment-card :recruitment="item" />
            </v-col>
        </template>
    </v-row>
</template>

<script>
import api from "@/api";

import MainRecruitmentCard from "@/components/client/main/main-recruitment-card.vue";

export default {
    components: {
        MainRecruitmentCard,
    },
    props: {
        params: { type: Object, default: () => ({}) },
    },
    data: () => ({
        recruitments: [],
        summary: { totalCount: 0 },

        loading: false,
    }),
    computed: {
        items() {
            const shuffled = this.recruitments.sort(() => 0.5 - Math.random());
            const selected = shuffled.slice(0, 3);
            return selected;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.init();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { params } = this;
                const { summary, recruitments } = await api.v1.recruitments.gets({
                    headers: { skip: 0, limit: 12 },
                    params,
                });
                this.summary = summary;
                this.recruitments = recruitments;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style>
</style>